import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const sessionApi = {
  createSession: async (data: any): Promise<ApiResponse<any>> => {
    return await axiosClient.post(`/class-sessions`, data);
  },
  getSessionByClassId: async (params: any) => {
    const res = await axiosClient.get('/class-sessions', { params });
    return res;
  },
  getSessionById: async (id: any) => {
    const res = await axiosClient.get(`/class-sessions/${id}`);
    return res;
  },
};

export default sessionApi;
